import React, { useEffect, useRef, useState, } from 'react'
import { iconwrapper } from '../../../../../../config/commonfunctions'
import { ADD_ICON, CROSS_ICON, TRASH_ICON } from '../../../../../../config/svgicons'
import { describe_dom, inputdescribe_dom, partialtitle_dom } from '../../../Invitationmaker/components/Commonelements/Commonelements'
import { v4 as uuidv4 } from 'uuid';
import './Addguestcontent.css'

const CROSSICON_CSS = { width: 20, height: 20, display: 'flex', placeContent: 'center' }

function Guest(props) {
    const { indexarr, id, rawguestrelas = [], rawguestcats = [], guestgrps = [], updateGuest, delthis } = props
    const [name, setName] = useState('')
    const [grp, setGrp] = useState('')
    const [cats, setCats] = useState([])
    const [relas, setRelas] = useState([]) // user selected relationships
    const [localindexarr, setLocalindexarr] = useState([])

    const [availableguestrelas, setAvailableguestrelas] = useState([]) // all the available relationships allow the user to choose
    const [availableguestcats, setAvailableguestcats] = useState([]) // all the available categories allow the user to choose

    useEffect(() => {
        updateGuest({
            id: id,
            name: name,
            relas: relas,
            cats: cats,
            grp: grp
        })
    }, [name, grp, relas, cats])

    useEffect(() => {
        setLocalindexarr(indexarr.slice())
    }, [indexarr])

    useEffect(() => {
        let new_availableguestrelas = []
        for (let i = 0; i < rawguestrelas.length; i++) {
            if (!relas.includes(rawguestrelas[i])) {
                new_availableguestrelas.push(rawguestrelas[i])
            }
        }
        setAvailableguestrelas(new_availableguestrelas)
    }, [rawguestrelas, relas])

    useEffect(() => {
        let new_availableguestcats = []
        for (let i = 0; i < rawguestcats.length; i++) {
            if (!cats.includes(rawguestcats[i])) {
                new_availableguestcats.push(rawguestcats[i])
            }
        }
        setAvailableguestcats(new_availableguestcats)
    }, [rawguestcats, cats])


    const name_dom = <>
        <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 55 }}>
            {partialtitle_dom('Guest Name', {})}
            <input
                style={{ width: '100%', height: 40 }}
                value={name}
                onChange={(e) => { setName(e.target.value) }}
            />
        </aside>
        <div style={{ height: 15 }} />
    </>

    const group_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Group', {})}
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
                <select
                    style={{ width: '100%', height: 40, border: '' }}
                    value={grp}
                    onChange={(e) => {
                        setGrp(e.target.value)
                    }}
                >
                    {["", ...guestgrps].map((item, y) => {
                        return <option
                            key={y + 'item'}
                            className="Rsvpexplorer_portaltag"
                        >
                            {item}
                        </option>
                    })}
                </select>
            </div>
        </aside>
        <div style={{ height: 15 }} />
    </>

    const relationship_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Relationship(s)', {})}
            <div style={{ width: '100%', minHeight: 52, height: 'auto', flexWrap: 'wrap', padding: 5, display: 'flex', flexDirection: 'row', position: 'relative', backgroundColor: 'rgb(244, 245, 246)', }}>
                {relas.length > 0
                    ? relas.map((item, index) => {
                        return (
                            <div key={item + index} className='Rsvpexplorer_portaltag' style={{ padding: '5px 0px 5px 14px' }} >
                                <div style={{ display: 'flex', alignContent: 'center', textAlign: 'center', paddingRight: 6 }}>
                                    {item}
                                </div>
                                <button
                                    style={{ padding: '0px 5px', color: '#b21212', backgroundColor: 'transparent', margin: 0, outline: 'none', border: 'none', }}
                                    onClick={(index) => {
                                        setRelas((arr) => {
                                            let new_arr = arr.slice()
                                            new_arr.splice(index, 1)
                                            return new_arr
                                        })
                                    }}
                                >
                                    {iconwrapper(CROSS_ICON, CROSSICON_CSS)}
                                </button>
                            </div>
                        )
                    })
                    : null}
            </div>
        </aside>
        {availableguestrelas.length > 0
            ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
                {inputdescribe_dom(
                    `${availableguestrelas.length} different relationships.`,
                    { padding: '5px 5px 0px 5px' })
                }
                <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
                    {availableguestrelas.map((item, y) => {
                        return <button
                            key={y + 'itemrela'}
                            className="Rsvpexplorer_portaltag"
                            onClick={() => {
                                setRelas((arr) => {
                                    let new_arr = arr.slice()
                                    new_arr.push(item)
                                    return new_arr
                                })
                            }}>
                            {item}
                        </button>
                    })}
                </div>
            </div>
            : null}
        <div style={{ height: 15 }} />
    </>

    const category_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Category', {})}
            <div style={{ width: '100%', minHeight: 52, height: 'auto', flexWrap: 'wrap', padding: 5, display: 'flex', flexDirection: 'row', position: 'relative', backgroundColor: 'rgb(244, 245, 246)', }}>
                {cats.length > 0
                    ? cats.map((item, index) => {
                        return (
                            <div key={item + index} className='Rsvpexplorer_portaltag' style={{ padding: '5px 0px 5px 14px' }} >
                                <div style={{ display: 'flex', alignContent: 'center', textAlign: 'center', paddingRight: 6 }}>{item}</div>
                                <button
                                    style={{ padding: '0px 5px', color: '#b21212', backgroundColor: 'transparent', margin: 0, outline: 'none', border: 'none', }}
                                    onClick={(index) => {
                                        setCats((arr) => {
                                            let new_arr = arr.slice()
                                            new_arr.splice(index, 1)
                                            return new_arr
                                        })
                                    }}
                                >
                                    {iconwrapper(CROSS_ICON, CROSSICON_CSS)}
                                </button>
                            </div>
                        )
                    })
                    : null}
            </div>
        </aside>
        {availableguestcats.length > 0
            ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
                {inputdescribe_dom(
                    `${availableguestcats.length} different categories.`,
                    { padding: '5px 5px 0px 5px' })
                }
                <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
                    {availableguestcats.map((item, y) => {
                        return <button
                            key={y + 'itemcat'}
                            className="Rsvpexplorer_portaltag"
                            onClick={() => {
                                setCats((arr) => {
                                    let new_arr = arr.slice()
                                    new_arr.push(item)
                                    return new_arr
                                })
                            }}>
                            {item}
                        </button>
                    })}

                </div>
            </div>
            : null}
        <div style={{ height: 15 }} />
    </>

    const index_and_trash_dom = <div className='Addguest_indexandtrashroot'>
        <div className='Addguest_index'>{localindexarr.indexOf(id) + 1}</div>
        <div
            className='Addguest_trash'
            onClick={() => { delthis(id) }}
        >
            {iconwrapper(TRASH_ICON, { width: 24, height: 24, display: 'flex', placeContent: 'center' })}
        </div>
    </div>


    return <div>
        <div id={id} className="Addguest_root" >
            {index_and_trash_dom}
            {name_dom}
            {group_dom}
            {relationship_dom}
            {category_dom}
        </div>
    </div>
}

function Addguestcontent(props) {
    const {
        guestcats = [],
        guestgrps = [],
        guestrelas = [],
        GUEST_MAX,
        update
    } = props

    const ADDICON_CSS = { width: 22, height: 22, display: 'flex', placeContent: 'center' }
    const btmref = useRef(null)
    const [indexarr, setIndexarr] = useState([])
    const [allguestdata, setAllguestdata] = useState([])
    const [allguests, setAllguests] = useState([])
    const [addstopper, setAddstopper] = useState(false)

    useEffect(() => {
        addnewguest()
    }, [])

    useEffect(() => {
        btmref.current.scrollIntoView({
            behavior: "smooth"
        });
    }, [allguests])

    const addnewguest = () => {
        setAddstopper(true)

        setAddstopper(() => {
            setAllguests((arr) => {
                let allguests = arr.slice()
                let currkey = uuidv4();
                let new_indexarr = indexarr.slice()
                new_indexarr.push(currkey)
                setIndexarr(new_indexarr)
                allguests.push(
                    <Guest
                        indexarr={new_indexarr}
                        id={currkey}
                        key={currkey}
                        guestgrps={guestgrps}
                        rawguestcats={guestcats}
                        rawguestrelas={guestrelas}

                        delthis={() => {
                            setIndexarr((indexarr) => {

                                let new_indexarr = indexarr.slice()
                                new_indexarr.splice(new_indexarr.indexOf(currkey), 1)

                                setAllguests((allguests) => {
                                    let new_allguests = allguests.slice()
                                    new_allguests.splice(new_indexarr.indexOf(currkey), 1)
                                    return new_allguests
                                })

                                setAllguestdata((allguestdata) => {
                                    let new_allguestdata = allguestdata.slice()
                                    for (let i = 0; i < new_allguestdata.length; i++) {
                                        const { id } = new_allguestdata[i]
                                        if (id === currkey) {
                                            new_allguestdata.splice(i, 1)
                                            break
                                        }
                                    }
                                    return new_allguestdata
                                })

                                return new_indexarr
                            })
                        }}

                        updateGuest={(data) => {
                            setAllguestdata((allguestdata) => {
                                let new_allguestdata = allguestdata.slice()
                                for (let i = 0; i < new_allguestdata.length; i++) {
                                    console.log(new_allguestdata[i].id, data.id)
                                    if (allguestdata[i].id === data.id) {
                                        new_allguestdata[i] = JSON.parse(JSON.stringify(data))
                                        break
                                    }
                                }
                                return new_allguestdata
                            })

                        }}
                    />
                )

                let local_allguestdata = allguestdata.slice()
                local_allguestdata.push({
                    "id": currkey,
                    "name": "",
                    "relas": [],
                    "cats": [],
                    "grp": ""
                })
                setAllguestdata(local_allguestdata)

                return allguests
            })
            return false
        })

    }

    return <div className='Rsvpexplorer_portal' >
        <div className='Rsvpexplorer_portaltitle'>Add New Guest</div>
        {describe_dom(`You can add a maximum of ${GUEST_MAX} guests.`, {})}
        <div style={{ display: 'flex', flexDirection: 'column', height: 'calc( 100% - 170px)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'auto', height: 'auto', width: '100%', overflowY: 'auto', padding: '0px 10px' }}>
                {allguests}
                <div ref={btmref} />
            </div>
            {allguests.length > 9
                ? null
                : !addstopper
                    ? <button
                        className={`Rsvpexplorer_portaladdnewguest`}
                        style={{ width: '100%', placeContent: 'center', minHeight: 40 }}
                        onClick={addnewguest}
                        disabled={addstopper}
                        >
                        {iconwrapper(ADD_ICON, ADDICON_CSS)}
                    </button>
                    : null}
            <button
                className='Rsvpexplorer_portalsave'
                onClick={() => {
                    update(allguestdata)
                }}
            >
                Update
            </button>
        </div>

    </div>

}

export default Addguestcontent

// import React, { useEffect, useRef, useState } from 'react'
// import { iconwrapper } from '../../../../../../config/commonfunctions'
// import { EMPTYSPACE, ARROWDOWN_SMALL } from '../../../../../../config/constants'
// import { ADD_ICON, CROSS_ICON } from '../../../../../../config/svgicons'
// import { describe_dom, partialtitle_dom } from '../../../Invitationmaker/components/Commonelements/Commonelements'

// function Addguestcontent(props) {
//     const { GUEST_MAX, update } = props
//     const [addguestnum, setAddguestnum] = useState(1)
//     const [addguestname, setAddguestname] = useState([''])
//     const [addguestrela, setAddguestrela] = useState([''])
//     const [addguestcat, setAddguestcat] = useState([''])
//     const [allcats, setAllcats] = useState([''])
//     const [catdd, setCatdd] = useState(-1) // category dropdown

//     const ADDICON_CSS = { width: 24, height: 24, display: 'flex', placeContent: 'center' }
//     const btmref = useRef(null)

//     useEffect(() => {
//         const { allcats } = props
//         setAllcats(allcats)
//     }, [props])

//     useEffect(()=>{
//         btmref.current.scrollIntoView({
//             behavior: "smooth"
//           });
//     },[addguestnum])

//     var inputitems = []
//     for (let i = 0; i < addguestnum; i++) {
//         const _i = i
//         inputitems.push(
//             <div key={_i + 'addguests'} className="scedit_troot" style={{ height: '' }}>
//                 <div style={{ display: 'flex', placeContent: 'space-between' }}>
//                     <div style={{ padding: '0px 5px 0px 0px', color: 'var(--mainpink)', display: 'flex', fontSize: 16 }}>{_i + 1}</div>
//                     <button
//                         className='scedit_ddbtn'
//                         onClick={() => {
//                             setAddguestnum(addguestnum - 1)
//                             setAddguestname((a) => {
//                                 a.splice(_i, 1)
//                                 return a
//                             })

//                             setAddguestrela((a) => {
//                                 a.splice(_i, 1)
//                                 return a
//                             })

//                             setAddguestcat((a) => {
//                                 a.splice(_i, 1)
//                                 return a
//                             })
//                         }}
//                     >
//                         {iconwrapper(CROSS_ICON, { width: 24, height: 24, color: 'var(--mainpink)' })}
//                     </button>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'row', }}>

//                     {EMPTYSPACE}
//                     <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

//                         <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 55 }}>
//                             {partialtitle_dom('Guest Name', {})}
//                             <input
//                                 style={{ height: 40, padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                 value={addguestname[_i] || ''}
//                                 onChange={(e) => {
//                                     var local_addguestname = addguestname.slice()
//                                     local_addguestname[_i] = e.target.value
//                                     setAddguestname(local_addguestname)
//                                 }} />
//                         </aside>

//                         <div style={{ height: 15 }} />

//                         <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
//                             {partialtitle_dom('Relationship', {})}
//                             <input
//                                 style={{ height: 40, padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                 value={addguestrela[_i] || ''}
//                                 onChange={(e) => {
//                                     var local_addguestrela = addguestrela.slice()
//                                     local_addguestrela[_i] = e.target.value
//                                     setAddguestrela(local_addguestrela)
//                                 }} />
//                         </aside>

//                         <div style={{ height: 15 }} />

//                         <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
//                             {partialtitle_dom('Category', {})}
//                             <div style={{ width: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
//                                 <input
//                                     style={{ height: 40, padding: 5, borderRadius: 5, width: 'calc( 100% - 30px )', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                     value={addguestcat[_i] || ''}
//                                     onChange={(e) => {
//                                         var local_addguestcat = addguestcat.slice()
//                                         local_addguestcat[_i] = e.target.value.toLowerCase()
//                                         setAddguestcat(local_addguestcat)

//                                     }} />
//                                 <button className="scedit_ddbtn" onClick={() => catdd === _i ? setCatdd(-1) : setCatdd(_i)}> {ARROWDOWN_SMALL}</button>
//                             </div>
//                         </aside>

//                         {catdd === _i
//                             ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
//                                 {/* <div style={{ backgroundColor: '#ff4e4e', color: 'white', width: '100%', textTransform: 'uppercase' }} onClick={() => setCatdd(-1)}>close</div> */}
//                                 <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
//                                     {allcats.map((item, y) => {
//                                         return <button
//                                             key={y + 'item'}
//                                             className="Rsvpexplorer_portaltag"
//                                             onClick={() => {
//                                                 var local_addguestcat = addguestcat.slice()
//                                                 local_addguestcat[_i] = item
//                                                 setAddguestcat(local_addguestcat)
//                                                 setCatdd(-1)
//                                             }}>
//                                             {item}
//                                         </button>
//                                     })}

//                                 </div>
//                             </div>
//                             : null}

//                     </div>
//                 </div>
//             </div>
//         )
//     }

//     const add = () => {
//         var local_addguestname = addguestname.slice()
//         var local_addguestrela = addguestrela.slice()
//         var local_addguestcat = addguestcat.slice()
//         local_addguestname.push('')
//         local_addguestrela.push('')
//         local_addguestcat.push('')
//         setAddguestname(local_addguestname)
//         setAddguestrela(local_addguestrela)
//         setAddguestcat(local_addguestcat)
//         setAddguestnum(addguestnum + 1)
//     }

//     return <div className='Rsvpexplorer_portal' >
//         <div className='Rsvpexplorer_portaltitle'>Add New Guest</div>
//         {describe_dom(`You can add a maximum of ${GUEST_MAX} guests.`, {})}
//         <div style={{ display: 'flex', flexDirection: 'column', height: 'calc( 100% - 170px)' }}>
//             <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'auto', height: 'auto', width: '100%', overflowY: 'auto', padding: '0px 10px' }}>
//                 {inputitems}
//                 <div ref={btmref}/>
//             </div>
//             {inputitems.length > 9
//                 ? null
//                 : <button className='Rsvpexplorer_portaladdnewguest' style={{ width: '100%', placeContent: 'center', minHeight: 40 }} onClick={add}>
//                     {iconwrapper(ADD_ICON, ADDICON_CSS)}
//                 </button>}
//             <button className='Rsvpexplorer_portalsave' onClick={() => update(addguestnum, addguestname, addguestrela, addguestcat)}>Update</button>
//         </div>

//     </div>

// }

// export default Addguestcontent